module.exports = __webpack_public_path__ + "files/ee0f43c68d5c968cf7ea594aada7fc6d.png";